export class ColumnManager {
  constructor(table) {
    this.table = table
    this.common = [
      {
        header: "ID",
        field: "id",
        placeholder: "",
        filter: { value: null, matchMode: "equals" },
        width: "70px",
      },
      {
        header: "Дата обновл.",
        field: "date_updated",
        placeholder: "",
        filter: { value: null, matchMode: "dateIs" },
      },
      {
        header: "Дата созд.",
        field: "date_created",
        placeholder: "",
        filter: { value: null, matchMode: "dateIs" },
      },
      {
        header: "Создан",
        field: "user_created.last_name",
        placeholder: "",
        filter: { value: null, matchMode: "contains" },
      },
      {
        header: "Обновлен",
        field: "user_updated.last_name",
        placeholder: "",
        filter: { value: null, matchMode: "contains" },
      }
    ]

    this.columnDefinitions = {
      specimens: {
        defaults: [
          "description",
          "taxa_id.scientific_name",
          "taxa_id.order",
          "source_id.place_id.name_ru",
        ],
        specialfields: [
          'counterpart',
          'reflink',
          // Фиксированные колонки таблицы (не входят в specific/selectable,
          // чтобы не дублироваться): номер образца и номер коллекции
          // обязаны всегда быть в fields запроса, иначе пропадают значения в #/short-номере
          'specimen_no',
          'subcoll_id.coll_id.collection_no',
          'taxa_id.*',
          "taxa_id.tree.id",
          "taxa_id.tree.scientific_name",
          "taxa_id.tree.rank",
          // Полная привязка и субколлекция обязательны для редактора
          // EditSpecimenSourceSubcoll (SelectSources/SelectSubcolls):
          // без них привязка недоступна для редактирования в панелях списков
          'source_id.*',
          'source_id.place_id.*',
          'subcoll_id.id',
          'subcoll_id.label',
          'subcoll_id.place_id.*',
          'subcoll_id.expedition_id.*',
          'subcoll_id.coll_id.id',
        ],
        specific: [
          {
            header: "Колл.",
            field: "subcoll_id.coll_id.collection_no",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Постфикс",
            field: "postfix",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Тип",
            field: "type",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "±",
            field: "counterpart",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Описание",
            field: "description",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Комментарий",
            field: "comments",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Таксон",
            field: "taxa_id.scientific_name",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Род",
            field: "taxa_id.genus",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Семейство",
            field: "taxa_id.family",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Отряд",
            field: "taxa_id.order",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Местонахождение",
            field: "source_id.place_id.name_ru",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Возраст",
            field: "source_id.age_description",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Субколлекция",
            field: "subcoll_id",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
            width: "260px",
          },
          {
            header: "Регистр.",
            field: "registration",
            placeholder: "",
            filter: { value: null, matchMode: "dateIs" },
          },
          {
            header: "Инв.",
            field: "verification",
            placeholder: "",
            filter: { value: null, matchMode: "dateIs" },
          },
          {
            header: "Доп. номер",
            field: "external_no",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          }
        ],
      },
      places: {
        defaults: ["name_ru", "description","notes"],
        specific: [
          {
            header: "Название",
            field: "name_ru",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Название(лат.)",
            field: "name",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Описание",
            field: "description",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Заметки",
            field: "notes",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
        ],
      },
      taxa: {
        defaults: ["scientific_name", "authorship", "rank", "order"],
        specialfields: ["hierarchy","parent_id.id", "tree.id", "tree.scientific_name","tree.rank"],
        specific: [
          {
            header: "Ранг",
            field: "rank",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Название",
            field: "scientific_name",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Автор",
            field: "authorship",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Род",
            field: "genus",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Семейство",
            field: "family",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Отряд",
            field: "order",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
        ],
      },
      collections: {
        defaults: ["collection_no","related_locs.place_id.name_ru", "notes"],
        specialfields: ["related_locs.id","related_locs.place_id.id","related_locs.place_id.name_ru","related_locs.expedition_id.id", "related_locs.expedition_id.year",  "related_locs.expedition_id.head"],
        specific: [
          {
            header: "Номер",
            field: "collection_no",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Местонахождения",
            field: "related_locs.place_id.name_ru",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Заметки",
            field: "notes",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          }
          
        ],
      },
      subcollections:{
        defaults: ["coll_id.collection_no","label","place_id.name_ru" ],
        specialfields:['coll_id.id','expedition_id.id','place_id.id'],
        specific: [
          {
            header: "Номер",
            field: "coll_id.collection_no",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Название",
            field: "label",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Год",
            field: "expedition_id.year",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Начальник",
            field: "expedition_id.head",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },          
          {
            header: "Местонахождения",
            field: "place_id.name_ru",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
        ],
      },
      sources:{
        defaults:["place_id.name_ru","label","age_description","stage_early","stage_late" ],
        specialfields:['place_id.*'],
        specific:[
          {
            header: "Местонахождения",
            field: "place_id.name_ru",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },          
          {
            header: "Описание",
            field: "label",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },           
          {
            header: "Стратиграфия",
            field: "age_description",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },           
          {
            header: "Ярус(начало)",
            field: "stage_early",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },           
          {
            header: "Ярус(конец)",
            field: "stage_late",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          }
        ]
      },
      expeditions: {
        defaults: ["head", "year", "organization", "collectors", "notes"],
        specific: [
          {
            header: "Год",
            field: "year",
            placeholder: "",
            filter: { value: null, matchMode: "equals" },
          },
          {
            header: "Начальник",
            field: "head",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Организация",
            field: "organization",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Участники",
            field: "collectors",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Заметки",
            field: "notes",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
        ],
      },
      references:{
        defaults: ["author", "year", "fullcitation", "doi"],
        specialfields:['title'],
        specific:[
          {
            header: "Автор",
            field: "author",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "Год",
            field: "year",
            placeholder: "",
            filter: { value: null, matchMode: "gte" },
          },
          {
            header: "Цитата",
            field: "fullcitation",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
          {
            header: "doi",
            field: "doi",
            placeholder: "",
            filter: { value: null, matchMode: "contains" },
          },
        ]
      }
    }

    this.tableConfig = this.table ? this.columnDefinitions[this.table] : null

    if (this.table && !this.tableConfig) {
      throw new Error(`Unknown table type: ${this.table}`)
    }

    this.currentColumnsList = this.tableConfig
      ? [...this.common, ...this.tableConfig.specific]
      : []
  }

  getFields() {
    if (!this.tableConfig) return []

    const fields = this.currentColumnsList.map((item) => item.field)
    if (this.tableConfig?.specialfields) {
      return [...fields, ...this.tableConfig.specialfields]
    }
    return fields
  }

  getDefaultColumns() {
    if (!this.tableConfig) return []

    return this.currentColumnsList.filter((col) =>
      this.tableConfig.defaults.includes(col.field),
    )
  }

  getAllColumns() {
    return this.currentColumnsList
  }
  
  getDefaultFiltersOfColumns() {
    const filters = {}
    this.currentColumnsList.forEach((col) => {
      filters[col.field] = col.filter
    })
    return filters
  }

  getDefaultDirectusPresets() {
    const allFields = this.getFields()
    const defaultColumns = this.getDefaultColumns()

    const tableParams = {
      params: {
        fields: allFields,
        limit: this.table === 'specimens' ? 32 : 27,
        page: 1,
        filter: { _and: [] },
        sort: "date_updated",
      },
      columns: {
        selected: defaultColumns,
      },
    }

    const interfaceDefault = {
      allfilters: false,
      details: false,
      showColumnsSelect: false,
      showShortNumber: false,
      hideRightPanel:true
      
    }

    const interfaceParams = {
      specimens: {
        specimenfilter: false,
        headercolors:{
          light:'#fafafa',
          dark:'#2a2a2b '
        },
      },
      places:{
        headercolors:{
          light:'#daf1e0',
          dark:'#4e694f '
        }
      },
      expeditions:{
        headercolors:{
          light:'#dac3b0',
          dark:'#664631 '
        }
      },
      collections:{
        headercolors:{
          light:'#dcf0f1',
          dark:'#316466 '
        }
      },
      subcollections:{
        headercolors:{
          light:'#dcf0f1',
          dark:'#316466 '
        }
      },
      sources:{
        headercolors:{
          light:'#f1dceb',
          dark:'#663135 '
        }
      },
      taxa:{
        headercolors:{
          light:'#dce2f1',
          dark:'#0b1475 '
        }
      },

    }

    return {
      table: tableParams,
      interface: {
        ...interfaceDefault,
        ...(interfaceParams[this.table] || {}),
      },
    }
  }

  static getDefaultPresets() {
    const tableNames = Object.keys(new ColumnManager().columnDefinitions)
    const presets = {}

    for (const tableName of tableNames) {
      const manager = new ColumnManager(tableName)
      presets[tableName] = manager.getDefaultDirectusPresets()
    }
     presets.etc = {
        showRightPanel: true,
        mainranks:false,
        showranks:false,
        mapwidth:50
     }
    return presets
  }
}
